import { Console } from 'console';
import Vue from 'vue'
// import {any} from '@/bin/global.extend'
//首页

let rpaComponents: any = [];

export default rpaComponents;

rpaComponents.push({
	name: '文生视频',
	path: '/',
	redirect: '/textToVideo'
})


		rpaComponents.push({
			component: Vue.component('videoEditorPage',(resolve) => require(['@/views/videoEditor/videoEditor.vue'], resolve)),
			name:"视频编辑",
			path:"/videoEditor",
			mate:{}
		});

		rpaComponents.push({
			component: Vue.component('appPage',(resolve) => require(['@/views/app/app.vue'], resolve)),
			name:"申请微信支付",
			path:"/app",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('textToVideoPage',(resolve) => require(['@/views/textToVideo/textToVideo.vue'], resolve)),
			name:"小说推文",
			path:"/textToVideo",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('creationListPage',(resolve) => require(['@/views/creationList/creationList.vue'], resolve)),
			name:"解压视频创作记录",
			path:"/creation-list",
			mate:{}
		});
    rpaComponents.push({
			component: Vue.component('audioCreatingPage',(resolve) => require(['@/views/audioCreating/audioCreating.vue'], resolve)),
			name:"生成中",
			path:"/audioCreating",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('TextToVideoCreator',(resolve) => require(['@/views/migu/videoPlay/videoPlay.vue'], resolve)),
			name:"发布视频",
			path:"/video-play",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('TextToVideoCreator',(resolve) => require(['@/views/migu/textToVideo/textToVideo.vue'], resolve)),
			name:"一语故事",
			path:"/migu",
			mate:{}
		});
		rpaComponents.push({
			path: '/migu-channel',
			name: 'miguChannel',
			beforeEnter: (to, from, next) => {
				localStorage.setItem('commonPub','true');
				localStorage.setItem('theme', 'New_Year');
				next('/migu?theme=New_Year');
			}
		});
		rpaComponents.push({
			component: Vue.component('creationRecordPage',(resolve) => require(['@/views/migu/works/works.vue'], resolve)),
			name:"创作记录",
			path:"/migu-works",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('searchSpeakerPage',(resolve) => require(['@/views/searchSpeaker/searchSpeaker.vue'], resolve)),
			name:"声音搜索",
			path:"/searchSpeaker",
			mate:{}
		});

		rpaComponents.push({
			component: Vue.component('smartTextPage',(resolve) => require(['@/views/smartText/smartText.vue'], resolve)),
			name:"智能文案",
			path:"/smartText",
			mate:{}
		});
        rpaComponents.push({
			component: Vue.component('protocolPage',(resolve) => require(['@/components/protocol/protocol-detail.vue'], resolve)),
			name:"protocolPage",
			path:"/protocol",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('privacyPage',(resolve) => require(['@/components/protocol/privacy-policy.vue'], resolve)),
			name:"privacyPage",
			path:"/privacy",
			mate:{}
		});
	
		rpaComponents.push({
			component: Vue.component('commonListPage',(resolve) => require(['@/components/protocol/protocol-common.vue'], resolve)),
			name:"commonListPage",
			path:"/commonList",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('sdkPage',(resolve) => require(['@/components/protocol/protocol-sdk.vue'], resolve)),
			name:"sdkPage",
			path:"/sdkList",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('chooseBgmPage',(resolve) => require(['@/views/chooseBgm/chooseBgm.vue'], resolve)),
			name:"chooseBgmPage",
			path:"/chooseBgm",
			mate:{}
		});
		rpaComponents.push({
			component: Vue.component('orderPage',(resolve) => require(['@/views/order/order.vue'], resolve)),
			name:"消费记录",
			path:"/order",
			mate:{}
		});

rpaComponents.push({
	component: Vue.component('protocolPage',(resolve) => require(['@/components/feige-protocol/protocol-detail.vue'], resolve)),
	name:"feigeProtocolPage",
	path:"/feige/protocol",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('privacyPage',(resolve) => require(['@/components/feige-protocol/privacy-policy.vue'], resolve)),
	name:"feigePrivacyPage",
	path:"/feige/privacy",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('commonListPage',(resolve) => require(['@/components/feige-protocol/protocol-common.vue'], resolve)),
	name:"feigeCommonListPage",
	path:"/feige/commonList",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('sdkPage',(resolve) => require(['@/components/feige-protocol/protocol-sdk.vue'], resolve)),
	name:"feigeSdkPage",
	path:"/feige/sdkList",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('brainHistoryPage',(resolve) => require(['@/views/brainHistory/brainHistory.vue'], resolve)),
	name:"brainHistoryPage",
	path:"/brainHistory",
	mate:{}
});

rpaComponents.push({
	component: Vue.component('sdkPage',(resolve) => require(['@/components/feige-protocol/protocol-sdk.vue'], resolve)),
	name:"feigeSdkPage",
	path:"/feige/sdkList",
	mate:{}
});

/****************************** 智能剪辑工具 ******************************/
rpaComponents.push({
	component: Vue.component('SmartClipPage',(resolve) => require(['@/views/smartClip/step1/step1.vue'], resolve)),
	name:"SmartClipPage",
	path:"/smart-clip",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('SmartClipStep2Page',(resolve) => require(['@/views/smartClip/step2/step2.vue'], resolve)),
	name:"SmartClipStep2Page",
	path:"/smart-clip-step2",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('SmartClipStep3Page',(resolve) => require(['@/views/smartClip/step3/step3.vue'], resolve)),
	name:"SmartClipStep3Page",
	path:"/smart-clip-step3",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('SmartClipStep4Page',(resolve) => require(['@/views/smartClip/step4/step4.vue'], resolve)),
	name:"SmartClipStep4Page",
	path:"/smart-clip-step4",
	mate:{}
});

/****************************** AI 小工具 ******************************/

rpaComponents.push({
	component: Vue.component('AIGoldStart',(resolve) => require(['@/views/AITools/AI-gold-start/AI-gold-start.vue'], resolve)),
	name:"AIGoldStart",
	path:"/ai-gold-start",
	mate:{}
});

rpaComponents.push({
	component: Vue.component('AITitle',(resolve) => require(['@/views/AITools/AI-title/AI-title.vue'], resolve)),
	name:"AITitle",
	path:"/ai-title",
	mate:{}
});

rpaComponents.push({
	component: Vue.component('AIDescription',(resolve) => require(['@/views/AITools/AI-description/AI-description.vue'], resolve)),
	name:"AIDescription",
	path:"/ai-description",
	mate:{}
});

rpaComponents.push({
	component: Vue.component('AIRewrite',(resolve) => require(['@/views/AITools/AI-rewrite/AI-rewrite.vue'], resolve)),
	name:"AIRewrite",
	path:"/ai-rewrite",
	mate:{}
});

rpaComponents.push({
	component: Vue.component('AIImage',(resolve) => require(['@/views/AITools/AI-image/AI-image.vue'], resolve)),
	name:"AIImage",
	path:"/ai-image",
	mate:{}
});
rpaComponents.push({
	component: Vue.component('DuplicateRemoval',(resolve) => require(['@/views/AITools/AI-duplicate-removal/AI-duplicate-removal.vue'], resolve)),
	name:"AIDuplicateRemoval",
	path:"/ai-duplicate-removal",
	mate:{}
});
